import React from 'react';

interface AuditIconProps {
  className?: string;
}

const AuditIcon: React.FC<AuditIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Clipboard with checkmark design */}
    <rect x="3" y="2" width="10" height="12" rx="1" stroke="currentColor" strokeWidth="1" fill="none"/>
    <rect x="5" y="1" width="6" height="2" rx="1" fill="currentColor"/>
    <path d="M6 7l1.5 1.5L10 6" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="6" y1="10" x2="10" y2="10" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
    <line x1="6" y1="12" x2="8" y2="12" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/>
  </svg>
);

export default AuditIcon;